module.exports = "/assets/a2f6bc93f4b12da6f62c65d893aeb2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CF.png
// module id = 2391
// module chunks = 0